import BaseImportProjectsView from "backbone/projects/views/base_import_projects_view.js"
import Template from "backbone/projects/templates/external_service.js.hamlc"

export default class ImportViaExternalServiceView extends BaseImportProjectsView
  events:
    "submit form"          : "startImport"
    "click .js-new-cancel" : "remove"

  renderedHtml: ->
    Template(collection: @collection)

  startImport: (e) ->
    e.preventDefault() if e
    $form = @$el.find("form")
    if $form.parsley().validate()
      $form.maskLoading()
      $.ajax
        url: $form.attr('action')
        data: $form.serialize()
        processData: false
        contentType: false
        type: 'GET'
        success: (data) =>
          $form.unmaskLoading()
          if data.count > 0
            for project in data.behance_projects
              @collection.unshift(behance_id: project.id, title: project.title)
            @afterSearch(count: data.count) if @afterSearch
          else
            contently.flash.notice("Sorry, we were unable to find any projects for that username.")
            @importInProgress = false
            @render()
        error: (xhr, status, error) ->
          $form.unmaskLoading()
          switch xhr.status
            when 404
              contently.flash.alert("No user was found with that username.")
            else
              msg = "Sorry, there was an problem fetching projects from <var>Behance.</var>"
              contently.flash.alert(msg)



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/import_via_external_service_view.js.coffee